// next
import NextLink from 'next/link';
// @mui
import { Box, Link, ListItemText, Tooltip } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
// auth
//
import Iconify from '../../iconify';
//

import { NavItemProps } from '../types';
import { StyledDotIcon, StyledIcon, StyledItem } from './styles';

// ----------------------------------------------------------------------

export default function NavItem({
  item,
  depth,
  open,
  active,
  isExternalLink,
  handleTongle,
  ...other
}: NavItemProps) {
  const { translate } = useLocales();

  const { title, path = '/?#', icon, info, children, disabled, caption } = item;

  const color = () => {
    // if (subItem) {
    //   return 'black';
    // }
    if (active && !item?.id) {
      return '#00AB55';
    }
    return 'gray';
  };

  const renderContent = (
    <StyledItem
      depth={depth}
      active={active}
      disabled={disabled}
      caption={!!caption}
      {...other}
      onClick={() => handleTongle?.()}
    >
      {icon && <StyledIcon>{icon}</StyledIcon>}

      {item?.id && (
        <StyledIcon>
          <StyledDotIcon active={active && !item?.id} />
        </StyledIcon>
      )}

      <ListItemText
        primary={`${translate(title)}`}
        secondary={
          caption && (
            <Tooltip title={`${translate(caption)}`} placement="top-start">
              <span>{`${translate(caption)}`}</span>
            </Tooltip>
          )
        }
        primaryTypographyProps={{
          noWrap: true,
          component: 'span',
          variant: !item?.id ? 'subtitle2' : 'body2',
          color: color(),
        }}
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
        }}
      />

      {info && (
        <Box component="span" sx={{ lineHeight: 0 }}>
          {info}
        </Box>
      )}

      {!!children && (
        <Iconify
          width={16}
          icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
          sx={{ ml: 1, flexShrink: 0 }}
        />
      )}
    </StyledItem>
  );

  const renderItem = () => {
    // ExternalLink
    if (isExternalLink)
      return (
        <Link href={path} target="_blank" rel="noopener" underline="none">
          {renderContent}
        </Link>
      );

    // Has child
    if (children) {
      return renderContent;
    }

    // Default
    return (
      <Link component={NextLink} href={path} underline="none">
        {renderContent}
      </Link>
    );
  };

  return <> {renderItem()} </>;
}
